module.exports = __webpack_public_path__ + "static/media/stripe-create-account_4.3ee1893b.png";